import React from 'react';
import { MessageCircle } from 'lucide-react';
import { Button } from './ui/button';

const WhatsAppCTA = ({ message = "Hi Ukiyo Tours! I'd like to know more." }) => {
  const handleClick = () => {
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/918591732501?text=${encodedMessage}`, '_blank');
  };

  return (
    <div className="flex justify-center py-12 animate-fade-in-up">
      <Button
        onClick={handleClick}
        size="lg"
        className="bg-[#B8964F] hover:bg-[#a67f3a] text-white text-lg px-10 py-6 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 group"
      >
        <MessageCircle className="mr-2 group-hover:rotate-12 transition-transform duration-300" size={24} />
        Plan Your Holiday on WhatsApp
      </Button>
    </div>
  );
};

export default WhatsAppCTA;
